var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M68.201,42.768c0.641,1.84,0.48,3.76-0.399,4.96L41.241,74.289l-15.76,4.32c-0.24,0.08-0.32,0-0.24-0.24l4.48-15.601 l26.561-26.561c1.2-0.96,3.12-1.04,4.96-0.32C32.121,65.009,32.041,65.089,32.041,65.089l-1.84,5.84c0,0,0.88,0.32,1.68,1.12 c0.8,0.801,1.04,1.76,1.04,1.76l6-1.84L68.201,42.768z M36.521,65.169l27.68-27.681c0.88,0.48,1.761,1.36,2.4,2.32 c-27.761,27.68-27.761,27.68-27.761,27.68l-2.24-0.08L36.521,65.169z M76.282,39.248l-5.12,5.2c0,0,2.479-3.84-2.721-8.88 c-4.56-4.56-8.88-2.56-8.88-2.56l5.2-5.2c3.2-3.28,8.4-3.68,11.76-0.4C79.962,30.848,79.481,36.128,76.282,39.248z"
  }))));
};
export default SvgPencil;